import { TypographyContent } from "../../atoms";

/**
 * Error object representing a validation error in form fields.
 * Contains error message content and validation metadata.
 */
export interface ErrorObject {
  /**
   * The error message content to display.
   * Supports localized content or plain strings.
   */
  content: TypographyContent;
  /**
   * The name of the validator that produced this error.
   * Used for context-specific error formatting.
   */
  validator?: string;
  /**
   * Additional options or context for the error.
   * May contain validator-specific data like format examples.
   */
  options?: Record<string, any>;
}

export function formatErrorContext({ validator, options }: ErrorObject): {
  [key: string]: any;
} {
  switch (validator) {
    case "format":
      return { example: options?.example };
    default:
      return options || {};
  }
}

export function processErrorContent(
  error: ErrorObject | undefined
): TypographyContent | undefined {
  if (!error) return undefined;

  return error && typeof error.content === "object" && "local" in error.content
    ? {
        ...error.content,
        local:
          typeof error.content.local === "string"
            ? {
                key: error.content.local,
                context: formatErrorContext(error),
              }
            : {
                ...(error.content.local as object),
                context: formatErrorContext(error),
              },
      }
    : error?.content;
}
